import React, { useState, useRef, useEffect, useCallback } from 'react';
import dayjs from 'dayjs';

import { AgGridReact } from 'ag-grid-react';
import { DatePicker, Input } from 'antd';
import moment from 'moment';
// import React from 'react';
// import { useEffect } from 'react';
// import { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import * as XLSX from 'xlsx';

import Skeleton from '@mui/material/Skeleton';

import MultiSelectDropdown from './MultiSelectDropdown';
import LdcApi from '../../LdcApis';
import { MdOutlineSimCardDownload } from 'react-icons/md';

const { RangePicker } = DatePicker;
// const aptData = [
//   { appointmentDate: '20/10/22', appointmentTime: '14:00', nameOfDoctor: 'Dr Gwanmesia', serviceBilled: 'Cyst Removel', receiptTotal: 399,patientId:34 },
//   { appointmentDate: '20/01/22', appointmentTime: '12:00', nameOfDoctor: 'Dr Asiya', serviceBilled: 'Cyst Removel', receiptTotal: 299,patientId:24 },
//   { appointmentDate: '20/10/22', appointmentTime: '14:00', nameOfDoctor: 'Dr Gwanmesia', serviceBilled: 'Cyst Removel', receiptTotal: 399,patientId:14 },
//   { appointmentDate: '20/10/22', appointmentTime: '14:00', nameOfDoctor: 'Dr Gwanmesia', serviceBilled: 'Cyst Removel', receiptTotal: 399,patientId:40 }
// ];

function WoundCheckTable() {
  useEffect(() => {
    document.title = 'Wound Check Report - LDC';
  }, []);
  const [serviceReportData, setServiceReportData] = useState([]);
  const [rowData, setRowData] = useState([]);

  const [loading, setLoading] = useState(false);
  const gridRef = useRef();
  const [filteredData, setFilteredData] = useState([]);
  const formatDisplay = 'DD/MM/YYYY';
  const formatAPI = 'YYYY/MM/DD';
  const todayDisplay = dayjs().format(formatDisplay);
  const todayAPI = dayjs().format(formatAPI);
  const threeMonthsAgoDisplay = dayjs()
    .subtract(3, 'months')
    .format(formatDisplay);
  const threeMonthsAgoAPI = dayjs().subtract(3, 'months').format(formatAPI);
  // const [options, setOptions] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [displayStartDate, setDisplayStartDate] = useState(
    threeMonthsAgoDisplay
  );
  const [displayEndDate, setDisplayEndDate] = useState(todayDisplay);
  const [apiStartDate, setApiStartDate] = useState(threeMonthsAgoAPI);
  const [apiEndDate, setApiEndDate] = useState(todayAPI);

  const [services, setServices] = useState([]);
  const [servicesAllList, setServicesAllList] = useState([]);
  const [appointmentDate, setAppointmentDate] = useState();
  // Convert the date string to a Date object
  const dateObject = new Date(appointmentDate);

  // Get the day, month, and year
  const day = String(dateObject.getDate()).padStart(2, '0');
  const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = dateObject.getFullYear();

  // Format the date as dd/mm/yyyy
  const formattedDate = `${day}/${month}/${year}`;

  console.log(formattedDate); // Output: 30/05/2024

  useEffect(() => {
    document.title = 'Wound Check Report Data - LDC';
    getServices();
  }, [apiStartDate, apiEndDate]);

  // Assuming 'res' is your array

  useEffect(() => {
    LdcApi({
      method: 'GET',
      url: 'ServiceMaster/GetServiceMastesExcludedTest',
    })
      .then((res) => {
        if (res?.data !== null) {
          setServicesAllList(res?.data);
        }
      })
      .catch((error) => {
        // callback({ status: error });
      });
  }, []);

  const getServices = () => {
    setLoading(true);
    LdcApi({
      method: 'GET',
      url: `Data/GetServiceReportWoundCheckData?startDate=${apiStartDate}&endDate=${apiEndDate}`,
    })
      .then((res) => {
        console.log('res', res);
        if (res?.data?.status?.isSuccess) {
          setServiceReportData(res?.data?.data);
          setRowData(res?.data?.data);
        } else {
          setServiceReportData([]);
        }

        // ----------------------------------------------------------------

        setFilteredData(services);
        const serviceOptions = [
          ...new Set(
            res.data.data.map((service) =>
              service.serviceDetails.split('-')[0].trim()
            )
          ),
        ].map((service) => ({ value: service, label: service }));

        // setOptions(serviceOptions);
        // filterTodayData(res.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //  filterChangedCallback();
  // }, [selectedServices]);

  const isServiceSelected = (service) => selectedServices.includes(service);

  const [columnDefs] = useState([
    {
      headerName: 'Appointment Date & Time',
      field: 'appointmentDate',
      field: 'startTime', // This field is used for sorting/filtering if needed
      cellRenderer: (params) => {
        const dateObject = new Date(params.data.appointmentDate);
        const formattedDate = dateObject.toLocaleDateString('en-GB'); // dd/mm/yyyy format
        const startTime = params.data.startTime;
        const datePart = params.data.appointmentDate.split('T')[0];
        const dateTimeString = `${datePart}T${params.data.startTime}`;
        const formattedTime = dateObject.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        });

        return `${formattedDate}  ${startTime}`;
      },

      width: 250,
      minWidth: 200,
      comparator: (valueA, valueB, nodeA, nodeB) => {
        // Combine appointmentDate and startTime for sorting
        const dateTimeA = new Date(
          `${nodeA.data.appointmentDate}T${nodeA.data.startTime}`
        );
        const dateTimeB = new Date(
          `${nodeB.data.appointmentDate}T${nodeB.data.startTime}`
        );

        return dateTimeB - dateTimeA; // Sorting in ascending order
      },
      width: 220,

      filter: false,
      sortable: true,
      resizable: true,
    },
    // {
    //   headerName: 'Appointment Time',
    //   field: 'appointmentTime',
    //   width: 200,
    //   minWidth: 100,
    //   filter: true
    // },
    {
      headerName: 'Patient Id',
      field: 'patientId',
      width: 150,
      minWidth: 100,
      filter: false,
      sortable: true,
      resizable: true,
    },
    {
      headerName: 'Name of Doctor ',
      field: 'doctorName',
      width: 250,
      minWidth: 100,
      filter: false,
      sortable: true,
      resizable: true,
    },
    {
      headerName: 'Service Billed',
      field: 'serviceDetails',
      width: 450,
      minWidth: 100,
      filter: false,
      resizable: true,

      // filter: "agSetColumnFilter", // Enable set filter for multi-select
      // filterParams: {
      //   values: services, // Populate filter values dynamically
      //   debounceMs: 500, // Optional debounce to delay the filter request
      //   caseSensitive: false, // Case insensitive filter
      //   suppressSelectAll: false, // Allows "Select All" option
      //   suppressMiniFilter: false, // Show the search box for filtering options
      // },
      sortable: true,
    },
    {
      headerName: 'Receipt Total ',
      field: 'paymentAmount',
      width: 200,

      filter: false,
      sortable: true,
      resizable: true,
      valueFormatter: (params) => {
        // Format the value with the Euro symbol
        return `£${params.value}`;
      },
    },
  ]);
  // const defaultColDef = {
  //   filter: true,
  //   sortable: true,
  //   floatingFilter: true,
  //   flex: 1,
  //   resizable: true,
  //   height: 100,
  //   minWidth: 100,
  // };

  const filterTodayData = (data) => {
    const todayFormatted = dayjs().format(formatDisplay);
    const todayData = data.filter(
      (item) => item.appointmentDate === todayFormatted
    );
    setFilteredData(todayData);
  };

  // const handleServiceChange = (selected) => {
  //   console.log("selected", selected); //[... /. ....] []
  //   if (selected.length > 0) {
  //     // serviceReportData  [.......]
  //     const serviceValues = selected.map((service) => service.value);
  //     console.log("serviceValues", serviceValues);

  //     const newValues = rowData.filter((item) =>
  //       serviceValues.includes(item.serviceDetails)
  //     );

  //     setServiceReportData(newValues);
  //   } else {
  //     setServiceReportData(rowData);
  //   }
  // };
  const handleServiceChange = (selected) => {
    console.log('selected', selected); // Logs the selected services

    if (selected.length > 0) {
      // Extract the service names from the selected options
      const selectedServiceNames = selected.map((service) =>
        service.label.toLowerCase()
      );

      console.log('selectedServiceNames', selectedServiceNames);

      // Replace 'serviceDetails' with the correct property name if it's different
      const newValues = rowData.filter((item) =>
        selectedServiceNames.some((selectedName) =>
          item.serviceDetails.toLowerCase().includes(selectedName)
        )
      );

      // Update the state with the filtered data
      setServiceReportData(newValues);
    } else {
      // If no services are selected, show all services
      setServiceReportData(rowData);
    }
  };

  console.log('rowData', rowData);
  // const filterTable = (selected) => {
  //   if (selected.length === 0) {
  //     setFilteredData(rowData); // Show all data if no services are selected
  //     return;
  //   }

  //   const filtered = rowData.filter((row) => {
  //     const serviceName = row.serviceDetails.split("-")[0].trim();
  //     return selected.some((service) => service.value === serviceName);
  //   });

  //   setFilteredData(filtered);
  // };

  const onDateRangeChange = (dates, dateStrings) => {
    if (dates === null) {
      setDisplayStartDate(threeMonthsAgoDisplay);
      setDisplayEndDate(todayDisplay);
      setApiStartDate(threeMonthsAgoAPI);
      setApiEndDate(todayAPI);
    } else {
      setDisplayStartDate(dateStrings[0]);
      setDisplayEndDate(dateStrings[1]);
      setApiStartDate(dayjs(dateStrings[0], formatDisplay).format(formatAPI));
      setApiEndDate(dayjs(dateStrings[1], formatDisplay).format(formatAPI));
    }
  };

  //   const onChange = (date, dateString) => {
  //     let filteraptDate = aptData.filter((item) => {
  //       return item.appointmentDate === dateString;
  //     });
  //     setServiceReportData(filteraptDate);
  //   };

  const options = servicesAllList.map((el) => {
    return {
      label: el.serviceName,
      value: el.serviceName,
    };
  });

  const onBtnExport = useCallback(() => {
    const transformedData = serviceReportData.map((item) => ({
      'Appointment Date & Time': `${new Date(item.appointmentDate).toLocaleDateString('en-GB')}     ${item.startTime}`,
      'Patient Id': item.patientId,
      'Name of Doctor ': item.doctorName,
      'Service Billed': item.serviceDetails,
      'Receipt Total ': `£${item.paymentAmount}`,
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Service Report');

    const wscols = [
      { wch: 25 },
      { wch: 15 },
      { wch: 20 },
      { wch: 50 },
      { wch: 20 },
    ];
    worksheet['!cols'] = wscols;

    XLSX.writeFile(workbook, 'Wound_Check_report.xlsx');
  }, [serviceReportData]);

  return (
    <div>
      <div style={{ display: 'flex' }}>
        <div>
          <Col>
            <RangePicker
              style={{ height: '38px', minWidth: '15vw' }}
              onChange={onDateRangeChange}
              format={formatDisplay}
              value={[
                dayjs(displayStartDate, formatDisplay),
                dayjs(displayEndDate, formatDisplay),
              ]}
            />
            {/* <Button
            type="primary"
            onClick={getPasword}
            style={{ backgroundColor: "Blue", marginLeft: "10px" }}
          >
            Show Data
          </Button> */}
          </Col>{' '}
        </div>
        <div style={{ position: 'relative', zIndex: 10, minWidth: '20vw' }}>
          <Col>
            {/* <MultiSelectDropdown
              style={{
                position: 'relative',
                zIndex: 10,
                minWidth: '50%',
                minWidth: '7vw',
              }}
              options={options}
              onChange={handleServiceChange}
            /> */}
          </Col>
          {/* <div style={{ position: 'relative', zIndex: 10, minWidth: '20vw' }}> */}

          {/* </div> */}
        </div>
        <div>
          <div
            className='d-flex mr justify-content-end'
            style={{ marginLeft: '30rem' }}
          >
            <Button className='btn btn-primary' onClick={onBtnExport}>
              Export <MdOutlineSimCardDownload style={{ color: '#fff' }} />
            </Button>
          </div>
        </div>
      </div>
      <div
        className='ag-theme-alpine mt-2'
        style={{ height: '90vh', width: '100%' }}
      >
        {loading ? (
          <div className='rounded'>
            {[...Array(20)].map((el, index) => (
              <Skeleton key={index} height={60} sx={{ bgcolor: '#e2e8f0' }} />
            ))}
          </div>
        ) : (
          <AgGridReact
            // ref={gridRef}
            rowData={serviceReportData}
            // filterTable={filterTable}
            // defaultColDef={defaultColDef}
            columnDefs={columnDefs}
            //   defaultColDef={defaultColDef}
            animateRows={true}
            //   onGridReady={onGridReady}
            pagination={true}
            paginationPageSize={50}
            debounceVerticalScrollbar={true}
            // paginationAutoPageSize={true}
          />
        )}{' '}
      </div>
    </div>
  );
}

export default WoundCheckTable;
